import React, { useState } from "react";
import { Icon } from "antd";
import { useTranslation } from "react-i18next";
import CampaignMap from "./CampaignMap";

const CampaignMapCard = ({ campaign, isCpmi }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const displays = (campaign.contents_displays || []).filter(
    (d) => d.display_latitude != null && d.display_longitude != null
  );

  if (displays.length === 0) {
    return null;
  }

  return (
    <div className="campaignDetail__card">
      <div className="campaignDetail__section-head">
        <div className="campaignDetail__section-title campaignDetail__map-title">{t("Map")}</div>
        <button type="button" className="campaignDetail__toggle" onClick={() => setOpen(!open)}>
          {open ? t("Hide") : t("Show")} <Icon type={open ? "up" : "down"} />
        </button>
      </div>
      {open && <CampaignMap displays={displays} t={t} isCpmi={isCpmi} />}
    </div>
  );
};

export default CampaignMapCard;
